import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import {EventService} from "../../core/services/event.service";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute} from "@angular/router";
import * as _ from "lodash";
import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import {Angulartics2} from "angulartics2";
declare var moment: any;

@Component({
    selector: 'emergency-tab',
    templateUrl: './emergency.contact.tab.html',
    styleUrls: ['./profile.page.scss']
})
export class ProfileEmergencyTab implements OnInit {
    @Output() onFormAdd = new EventEmitter();
    form: NgForm;

    dictData: any;
    model: any;
    state: any = {
        isSubmitted: false
    };

    isCreation: boolean;
    isFormVisible: boolean = false;
    editModel: any;

    @ViewChild('form') set content(content: NgForm) {
        this.form = content;
    }

    constructor(
        private route: ActivatedRoute,
        private eventService: EventService,
        private http: HttpClient,
        private toastr: ToastrService,
        private angulartics2: Angulartics2
    ) {}

    ngOnInit() {
        this.dictData = this.route.snapshot.data['common'];
        this.convertToModels(this.eventService.selectedEvent.gql);
        this.eventService.onEventChange.subscribe(event => {
            this.convertToModels(this.eventService.selectedEvent.gql);
        });
        this.eventService.onGqlReload.subscribe(() => {
            this.convertToModels(this.eventService.selectedEvent.gql);
        });
        this.angulartics2.eventTrack.next({
            action: 'View Emergency Contacts',
            properties: {category: 'Profile'}
        });
    }

    convertToModels(gqlRes) {
        this.model = {
            emergencyContacts: []
        };
        if (!gqlRes) return;

        let emergencyContacts = gqlRes.Participant[0].emergencyContacts;
        emergencyContacts.forEach(contact => {
            this.model.emergencyContacts.push({
                constituentEmergencyContactID: contact.emergencyContactId,
                firstName: contact.contactFirstName,
                lastName: contact.contactLastName,
                emergencyContactType: {
                    emergencyContactTypeId: contact.emergencyContactType.emergencyContactTypeId,
                    name: contact.emergencyContactType.name,
                    description: contact.emergencyContactType.description
                },
                constituentRelationshipType: {
                    constituentRelationshipTypeId: contact.constituentRelationshipType.constituentRelationshipTypeId,
                    name: contact.constituentRelationshipType.name,
                    description: contact.constituentRelationshipType.description
                },
                emergencyContactPhones: [{
                    areaCode: contact.emergencyContactPhones[0].areaCode,
                    phoneNumber: (contact.emergencyContactPhones[0].areaCode ? '(' + contact.emergencyContactPhones[0].areaCode + ') ' : '') + contact.emergencyContactPhones[0].phoneNumber,
                    phoneType: {
                        constituentPhoneTypeID: contact.emergencyContactPhones[0].phoneType.cmgmtPhoneTypeId
                    },
                    primary: contact.emergencyContactPhones[0].primaryFl
                }]
            });
        });
    }

    /** Edit/create **/
    cancel() {
        this.isFormVisible = false;
        this.editModel = null;
        this.state.isSubmitted = false;
    }

    create() {
        this.isCreation = true;
        this.isFormVisible = true;
        this.editModel = {
            emergencyContactType: {},
            constituentRelationshipType: {},
            emergencyContactPhones: [{
                phoneType: {},
                primary: false
            }]
        };
        this.angulartics2.eventTrack.next({
            action: 'Add contact',
            properties: {category: 'Profile'}
        });
        setTimeout(() => {
            this.onFormAdd.emit(this.form);
        }, 1);
    }

    edit(contact) {
        this.isCreation = false;
        this.isFormVisible = true;
        this.editModel = _.cloneDeep(contact);
        setTimeout(() => {
            this.onFormAdd.emit(this.form);
        }, 1);
    }

    save() {
        this.state.isSubmitted = true;
        if (!this.form.valid) return;
        this.form.form.markAsPristine();
        // reformat for backend
        let updateData = _.cloneDeep(this.editModel);
        updateData.constituentRelationshipTypeId = updateData.constituentRelationshipType.constituentRelationshipTypeId;
        delete updateData.constituentRelationshipType;
        updateData.emergencyContactTypeId = updateData.emergencyContactType.emergencyContactTypeId;
        delete updateData.emergencyContactType;
        if (this.isCreation) {
            this.http.post(`/api/v1/user/participant/${this.eventService.selectedEvent.participantId}/emergency/contacts`, updateData)
                .subscribe(res => {
                    this.eventService.getEmergencyContacts(true).subscribe(() => {});
                    this.toastr.success('Emergency contact added.');
                }, err => {
					this.toastr.error("There was a problem creating the emergency contact");
				});
        } else {
            this.http.post('/api/v1/emergency/contacts/' + this.editModel.constituentEmergencyContactID, updateData)
                .subscribe(res => {
                    this.eventService.getEmergencyContacts(true).subscribe(() => {});
                    this.toastr.success('Emergency contact updated.');
                }, err => {
					this.toastr.error("There was a problem updating the emergency contact");
				});
        }
        this.isFormVisible = false;
        this.state.isSubmitted = false;
    }

    delete(email) {
        this.http.delete('/api/v1/emergency/contacts/' + email.constituentEmergencyContactID)
            .subscribe(res => {
                this.eventService.getEmergencyContacts(true).subscribe(() => {});
                this.toastr.success('Emergency contact deleted.');
                this.angulartics2.eventTrack.next({
                    action: 'Delete contact',
                    properties: {category: 'Profile'}
                });
            });
    }
}

